import type { CountryCodes, Rv } from '~/types/api'

export default (rv?: Rv) => {
  const geolocation = useGeolocation()

  let url = null

  switch (geolocation.country as CountryCodes) {
    case 'CA':
      url = new URL('https://v2.digital.dealertrack.ca/creditapp/standalone?token=ddf8a681-cd22-494c-bbe2-f590d26a1538&flow=Full&lang=en')

      if (rv) {
        url.searchParams.append('purchase_price', rv.listPrice?.toString() ?? '0')
        url.searchParams.append('what_will_you_be_purchasing', rv.name ?? 'Rv')
      }

      break

    case 'US':
      break
  }

  return url?.href
}
